import React from 'react'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import isStoreBagLine from '@/lib/basket/isStoreBagLine'
import { useMoveToWishlist } from '@/lib/hook/useWishlistMutation'
import { ProductsBasket } from '@/type/basket'

type Props = {
  product: {
    product_id?: string
    item_id?: string
    extra?: ProductsBasket['extra']
  }
}

const CartSaveForLater: React.FC<Props> = ({ product }) => {
  const { moveToWishlist } = useMoveToWishlist()
  const [loading, setLoading] = React.useState(false)
  // Le rendu est un <div> : il n'accepte pas `disabled`, et `loading` lu depuis la
  // closure du render courant n'est pas encore a jour entre deux clics rapproches.
  // Ce ref garantit une seule requete en vol par item (cf. RestApiError 404/doublon).
  const inFlightRef = React.useRef(false)

  const handleSaveForLater = async () => {
    if (!product.product_id || !product.item_id) return
    if (inFlightRef.current) return
    inFlightRef.current = true
    setLoading(true)
    try {
      await moveToWishlist({
        product_id: product.product_id,
        item_id: product.item_id,
      })
    } finally {
      inFlightRef.current = false
      setLoading(false)
    }
  }

  // Ligne PLV : la mettre de côté puis la reprendre la recréerait sans son budget de campagne
  // (commande détachée de la participation, frais de gestion facturés). Depuis le 15/09/2026,
  // le produit masqué ne revient d'ailleurs plus au panier depuis les favoris.
  if (isStoreBagLine(product)) return null

  return (
    <div
      onClick={handleSaveForLater}
      aria-disabled={loading}
      style={{ opacity: loading ? 0.5 : 1, pointerEvents: loading ? 'none' : undefined }}
      className="flex items-center gap-1 text-[11px] underline disabled:opacity-50 cursor-pointer transition-colors whitespace-nowrap"
    >
      <FavoriteBorderIcon sx={{ fontSize: 14 }} />
      Mettre de côté
    </div>
  )
}

export default CartSaveForLater
